import { render, staticRenderFns } from "./alcatel-brand.vue?vue&type=template&id=4c8b9c35"
import script from "./alcatel-brand.vue?vue&type=script&lang=js"
export * from "./alcatel-brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports